var _rect, _path, _rect2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrokenPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.913,
    width: 12.174,
    height: 16.522,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.726 15.652L4.826 20H3.087l3.093-4.602.001.008 1.545-2.655-4.204-3.186L9.96 1.74l1.123.927L5.696 9.13l3.858 3.345-1.828 3.177z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.913,
    width: 12.174,
    height: 4.348,
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.391,
    y: 1.739,
    width: 5.217,
    height: 0.87,
    rx: 0.435,
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC45MTMwODYiIHdpZHRoPSIxMi4xNzM5IiBoZWlnaHQ9IjE2LjUyMTciIHJ4PSIyIiAvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNzI1NjMgMTUuNjUyMkw0LjgyNjE3IDIwSDMuMDg3MDRMNi4xNzk3NyAxNS4zOTc4TDYuMTgxMTggMTUuNDA2TDcuNzI1NjMgMTIuNzUxMUwzLjUyMTgyIDkuNTY1MjJMOS45NjA0NSAxLjczOTE0TDExLjA4MjYgMi42NjU1TDUuNjk1NzMgOS4xMzA0NEw5LjU1Mzg3IDEyLjQ3NTJMNy43MjU2MyAxNS42NTIyWiIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMC45MTMwODYiIHdpZHRoPSIxMi4xNzM5IiBoZWlnaHQ9IjQuMzQ3ODMiIHJ4PSIyIiAvPgo8cmVjdCB4PSI0LjM5MTM2IiB5PSIxLjczOTE0IiB3aWR0aD0iNS4yMTczOSIgaGVpZ2h0PSIwLjg2OTU2NSIgcng9IjAuNDM0NzgzIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgBrokenPhone as ReactComponent };